// extracted by mini-css-extract-plugin
var _1 = "_branchesDetailsForm-module__button-container";
var _2 = "_branchesDetailsForm-module__button-subcontainer";
var _3 = "_branchesDetailsForm-module__container";
var _4 = "_branchesDetailsForm-module__form-container";
var _5 = "_branchesDetailsForm-module__joint-account-details-container";
var _6 = "_branchesDetailsForm-module__span-2";
export { _1 as "button-container", _2 as "button-subcontainer", _3 as "container", _4 as "form-container", _5 as "joint-account-details-container", _6 as "span-2" }
